import { Injectable } from '@angular/core';
import {
  CategoryPageMetaResolver,
  CmsService,
  TranslationService,
  BasePageMetaResolver,
  PageType,
  BreadcrumbMeta,
  ProductSearchService,
  isNotNullable,
} from '@spartacus/core';
import { Observable, combineLatest, of } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';
import { CategoryPageService } from 'src/app/customServices/category-page.service';

@Injectable({
  providedIn: 'root',
})
export class KbCategoryPageMetaResolver extends CategoryPageMetaResolver {
  breadCrubms$ = this.clpService.categoryData.pipe(
    filter(isNotNullable),
    map((model) => model['kbbreadcrumbs']),
    map((customBreadcrumbs) => {
      const breadcrumbs: BreadcrumbMeta[] = [];
      customBreadcrumbs.forEach((item, index) => {
        breadcrumbs.push({
          link: index + 1 === customBreadcrumbs.length ? '' : 'c/' + item.facetValueCode,
          label: item.facetValueName,
        });
      });
      return breadcrumbs;
    })
  );

  constructor(
    protected override productSearchService: ProductSearchService,
    public clpService: CategoryPageService,
    protected override cms: CmsService,
    protected override translation: TranslationService,
    protected override basePageMetaResolver: BasePageMetaResolver
  ) {
    super(productSearchService, cms, translation, basePageMetaResolver);

    this.pageType = PageType.CATEGORY_PAGE;
  }

  override resolveTitle(): Observable<string> {
    return this.breadCrubms$.pipe(
      mergeMap((breadCrubms) => {
        if (breadCrubms?.length) {
          return of(breadCrubms[breadCrubms.length - 1]?.label + ' | B2Bendix');
        }
        return this.basePageMetaResolver.resolveTitle();
      })
    );
  }
  override resolveBreadcrumbs(): Observable<BreadcrumbMeta[]> {
    return combineLatest([this.breadCrubms$, this.translation.translate('common.breadcrumb_home')]).pipe(
      map(([customBreadcrumbs, homeLabel]) => {
        const breadcrumbs: BreadcrumbMeta[] = [];
        breadcrumbs.push({ label: homeLabel, link: '/' });
        if (customBreadcrumbs?.length) {
          customBreadcrumbs.forEach((item) => {
            breadcrumbs.push(item);
          });
        }
        return breadcrumbs;
      })
    );
  }
}
